'use strict';

var Loadable = require('@loadable/component');

var _require = require('react-lazy-hydration'),
    LazyHydrate = _require["default"];
/* eslint-disable object-shorthand */


module.exports = {
  loadable: Loadable["default"],
  lazy: Loadable.lazy,
  loadableReady: Loadable.loadableReady,
  LazyHydrate: LazyHydrate
};
